import React, { useEffect, Fragment, useRef, useState } from "react";
import cx from "classnames";
import { Input } from "reactstrap";
import Autosuggest from 'react-autosuggest';
import requestApi from "../../services/requestApi.service";
import './assets/suggestion.css';

const CratioSuggestBox = (props) => {
  const [suggestions, setSuggestionData] = useState([])
  const [filteredSuggestion, setFilteredSuggestionData] = useState([])
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    (async () => {
      await loadSuggestions();
    })();
    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  const loadSuggestions = async () => {
    let params = {
      ENTITY: "FORMPROCESS",
      OPERATION: "LOAD_SUGGESTIONS",
      FIELDNAME : props.attributes.fieldName,
      FORMNAME : props.attributes.formname,
    };

    let response = await requestApi.processServerRequest(
        params,
        "WebV2",
        "get"
    );
    if (response.issuccess) {
      let suggestionlist = response.data;
      setSuggestionData(suggestionlist);
      setFilteredSuggestionData(suggestionlist);
    }
  }

  const onChange = async (e, newValue) => {
    if (newValue !== undefined) {
      let name = props.attributes.fieldName;
      let value = newValue['newValue'];
      if (props.onChange) {
        props.onChange(e, {name: name, value: value}, props.attributes);
      }
      setValue(value);
    }
  };

  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
      return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');
    return suggestions.filter(suggestion => regex.test(suggestion.label));
  }

  const onSuggestionsFetchRequested = ({ value }) => {
    setFilteredSuggestionData(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setFilteredSuggestionData([]);
  };

  function getSuggestionValue(suggestion) {
    return suggestion.label;
  }

  function renderSuggestion(suggestion) {
    return (
        <span>{suggestion.label}</span>
    );
  }

  const inputProps = {
    placeholder: "",
    value,
    onChange: onChange,
    className : "form-control"
  };
  return (
      <div>
        <Autosuggest
            suggestions={filteredSuggestion}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
        />
      </div>

  );
};

export default CratioSuggestBox;
